import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Esto oculta textos sensibles (como nombres de clientes o tarjetas) en los videos
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,

  beforeSend(event) {
    // ruido común
    const msg = event.exception?.values?.[0]?.value ?? "";
    if (
      msg.includes("ResizeObserver loop") ||
      msg.includes("chrome-extension")
    ) {
      return null;
    }
    return event;
  },
});

Sentry.setTag("app", "menu");
// Justo aquí abajo
Sentry.setTag("app_version", import.meta.env.VITE_APP_VERSION);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
